import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

/*
import 'firebase/compat/firestore';
import firebase from "firebase/compat/app";
import { getAuth } from "firebase/auth";
*/
import { auth } from "utils/firebase";
import { onAuthStateChanged } from 'firebase/auth';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

// context kiosk general codes & location codes
import { CodeProviderKiosk } from "./contexts/codeContextKiosk";
import { LocationProviderKiosk } from "./contexts/locationContextKiosk";

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // useEffect(() => {
  //   auth.onAuthStateChanged((user) => {
  //     if (user) {
  //       setIsAuthenticated(true);
  //     } else {
  //       setIsAuthenticated(false);
  //     }
  //   });
  // }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });

    // Clean up subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <CodeProviderKiosk>   {/* 👈 Context Provider : Code 추가 */}
          <LocationProviderKiosk> {/* 👈 Context Provider : Location 추가 */}
            <NavigationScroll>
              <Routes isAuthenticated={isAuthenticated} />
            </NavigationScroll>
          </LocationProviderKiosk>
        </CodeProviderKiosk>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
